import request from '@/utils/request';
import {
  AddSubjectMatterInterface,
  BatchDispatchInterface,
  BatchDispatchResponseInterface,
  BatchTransferSectorInterface,
  BatchUncorrelatedInterface,
  DealerTransferInterface,
  DispatchDealerInterface,
  DispatchUserInterface,
  GetDealerSalesInterface,
  GetFirstNoticeStatusInterface,
  GetNextPendingNoticeItemResponseInterface,
  GetNextPendingNoticeListInterface,
  NoticeDispatchInterface,
  NoticeItemInterface,
  NoticeListPropsInterface,
  NoticeListResponseInterface,
  NoticeRelationInterface,
  NoticeRelationResponseInterface,
  ProcessedNoticeType,
  QueryOperationRecordInterface,
  QueryRelationNoticeInterface,
  RecallInterface,
  SubjectMatterCheckInterface,
  SubjectMatterRecordInterface,
  SubjectProjectRecordInterface,
  UpdateSectorInterface
} from './type';

export const addNotice = (data: NoticeItemInterface): Promise<{}> => {
  return request({
    url: '/notice/addNotice',
    method: 'post',
    data
  });
};

export const getAnnDetail = (noticeCode: string): Promise<any> => {
  return request({
    url: '/notice/getDetail',
    method: 'post',
    data: { noticeCode }
  });
};

export const getProjectDetail = (noticeProjectCode: string): Promise<{}> => {
  return request({
    url: '/project/detail',
    method: 'post',
    data: { noticeProjectCode }
  });
};

export const addSubjectMatter = (
  data: AddSubjectMatterInterface
): Promise<{}> => {
  return request({
    url: '/subjectMatter/add',
    method: 'post',
    data
  });
};

export const updateSubjectMatter = (
  data: AddSubjectMatterInterface
): Promise<{}> => {
  return request({
    url: '/subjectMatter/update',
    method: 'post',
    data
  });
};

export const queryNoticeList = (
  data: NoticeListPropsInterface
): Promise<NoticeListResponseInterface> => {
  return request({
    url: '/notice/queryNoticeList',
    method: 'post',
    data
  });
};

export const deleteSubjectMatter = (
  subjectMatterCode: string[]
): Promise<{}> => {
  return request({
    url: '/subjectMatter/delete',
    method: 'post',
    data: { subjectMatterCode }
  });
};

export const queryDispatchUser = (data: DispatchUserInterface): Promise<{}> => {
  return request({
    url: '/system/user/queryDispatchUser',
    method: 'post',
    data
  });
};

export const queryDispatchDefaultUser = (
  data: DispatchUserInterface
): Promise<{}> => {
  return request({
    url: '/system/user/queryDispatchDefaultUser',
    method: 'post',
    data
  });
};

export const noticeDispatch = (data: NoticeDispatchInterface): Promise<{}> => {
  return request({
    url: '/notice/dispatch',
    method: 'post',
    data
  });
};

export const noticeRelation = (
  data: NoticeRelationInterface
): Promise<NoticeRelationResponseInterface> => {
  return request({
    url: '/notice/relation',
    method: 'post',
    data
  });
};

export const queryRelationNotice = (
  data: QueryRelationNoticeInterface
): Promise<{}> => {
  return request({
    url: '/notice/queryRelationNotice',
    method: 'post',
    data
  });
};

export const queryOperationRecord = (
  data: QueryOperationRecordInterface
): Promise<any> => {
  return request({
    url: '/record/queryOperationRecord',
    method: 'post',
    data
  });
};

export const queryProjectList = (data: {
  keyword: string;
  subjectMatterProjectCode?: string;
  dataFlag?: number;
}): Promise<any> => {
  return request({
    url: '/project/queryProjectList',
    method: 'post',
    data
  });
};

export const subjectMatterMark = (
  data: SubjectMatterRecordInterface
): Promise<any> => {
  return request({
    url: '/subjectMatter/mark',
    method: 'post',
    data
  });
};

export const subjectMatterCheckAi = (data: {
  subjectMatterCode: string;
  noticeProjectCode: string;
}): Promise<boolean> => {
  return request({
    url: '/subjectMatter/checkClassTypeAi',
    method: 'post',
    data
  });
};

export const SalesTransfer = (
  data: SubjectMatterRecordInterface
): Promise<any> => {
  return request({
    url: '/notice/salesTransfer',
    method: 'post',
    data
  });
};

export const dispatchDealer = (data: DispatchDealerInterface): Promise<any> => {
  return request({
    url: '/notice/dispatchDealer',
    method: 'post',
    data
  });
};
export const dealerTransfer = (data: DealerTransferInterface): Promise<any> => {
  return request({
    url: '/notice/dealerTransfer',
    method: 'post',
    data
  });
};

export const ProcessedNotice = (data: ProcessedNoticeType): Promise<any> => {
  return request({
    url: '/notice/completedNotice',
    method: 'post',
    data
  });
};

export const SalesTransferProject = (
  data: SubjectProjectRecordInterface
): Promise<any> => {
  return request({
    url: '/project/salesTransferProject',
    method: 'post',
    data
  });
};

export const subjectMatterCheck = (
  data: SubjectMatterCheckInterface
): Promise<any> => {
  return request({
    url: '/subjectMatter/check',
    method: 'post',
    data
  });
};

export const getFirstNoticeStatus = (
  data: GetFirstNoticeStatusInterface
): Promise<any> => {
  return request({
    url: '/notice/getFirstNoticeStatus',
    method: 'post',
    data
  });
};

export const updateSector = (data: UpdateSectorInterface): Promise<any> => {
  return request({
    url: '/notice/updateSector',
    method: 'post',
    data
  });
};

export const batchDispatch = (
  data: BatchDispatchInterface
): Promise<BatchDispatchResponseInterface> => {
  return request({
    url: '/notice/batchDispatch',
    method: 'post',
    data
  });
};

// 批量不相关
export const batchUncorrelated = (
  data: BatchUncorrelatedInterface
): Promise<BatchDispatchResponseInterface> => {
  return request({
    url: 'notice/batchUncorrelated',
    method: 'post',
    data
  });
};

// 批量转交sector
export const batchTransferSector = (
  data: BatchTransferSectorInterface
): Promise<BatchDispatchResponseInterface> => {
  return request({
    url: 'notice/batchTransferSector',
    method: 'post',
    data
  });
};

// 获取后续待处理公告
export const getNextPendingNoticeList = (
  data: GetNextPendingNoticeListInterface
): Promise<GetNextPendingNoticeItemResponseInterface[]> => {
  return request({
    url: '/notice/getNextPendingNoticeList',
    method: 'post',
    data
  });
};

// 批量重复
export const batchRepeat = (
  data: BatchUncorrelatedInterface
): Promise<BatchDispatchResponseInterface> => {
  return request({
    url: 'notice/batchRepeat',
    method: 'post',
    data
  });
};

export const noticeRecall = (data: RecallInterface): Promise<{}> => {
  return request({
    url: '/notice/recall',
    method: 'post',
    data
  });
};

export const dealerReturn = (data: RecallInterface): Promise<{}> => {
  return request({
    url: '/notice/dealerReturn',
    method: 'post',
    data
  });
};

export const subjectMatterRecall = (data: RecallInterface): Promise<{}> => {
  return request({
    url: '/subjectMatter/recall',
    method: 'post',
    data
  });
};

export const getDealerSales = (data: GetDealerSalesInterface): Promise<{}> => {
  return request({
    url: '/system/user/getDealerSales',
    method: 'post',
    data
  });
};
